export default [
    'uorazor'
  ];
  